///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../../abstract-command';
import { ActivityDTO } from '../../../../../../services/project-socket/activity-dto.model';
import { ProjectDesignConfigDTO } from '../../../../../../generated/shared-types.model';

export class GtthGetDesignConfigCommand extends GtthAbstractCommand {
    private designConfig: ProjectDesignConfigDTO;

    getDesignConfig(): ProjectDesignConfigDTO {
        return this.designConfig;
    }

    getCommandName(): string {
        return 'GtthGetDesignConfigCommand';
    }

    protected doCommand(): void {
        const activityDto = this.createActivityDTO(false);
        this.sendActivity(activityDto);
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        if (!activityDto.successful) {
            this.historyService.notificationService.showError(activityDto?.error?.message);
            this.commandResolve(false);
        } else {
            this.designConfig = activityDto.designConfig;
            this.commandResolve(true);
        }
    }

    isDisabledInReadOnlyMode(): boolean {
        return true;
    }
}
